import { request } from '../utils/request'
import { baseURLCommon, APIURLNEW, APIURLCPS } from '@/contants'


export function getActivityPwd (data) {
  return request({
    url: '/yh/activityRes',
    method: 'post',
    data
  }, APIURLNEW)
}

export function getH5Page (key) {
  return request({
    url: `/api/h5page/${key}`,
  }, APIURLNEW)
}

export function getJdLj ({...params}) {
  return request({
    url: `/yh/getJdLjs`,
    params
  }, APIURLNEW)
}

// export function getPresale (params) {
//   return request({
//     url: '/taobao/618pre',
//     params
//   }, TKURL)
// }

export function getUnionProd ({material_id, ...params}) {
  return request({
    url: `/api/prod/${material_id}`,
    params
  }, APIURLNEW)
}

export function getUnionDetail (id) {
  return request({
    url: `/api/aliAct/${id}`,
  }, APIURLNEW)
}

export function getProductPwd (data) {
  return request({
    url: '/yh/tbPrivilege',
    method: 'post',
    data
  }, APIURLNEW)
}

export function transformUrl (data, interceptors) {
  return request({
    url: '/agent/tool/cpsActivityUrl',
    method: 'post',
    data
  }, baseURLCommon, interceptors)
}

export function transform3Url(data, interceptors) {
  return request({
    url: '/agent/tool/cps3Url',
    method: 'post',
    data
  }, baseURLCommon, interceptors)
}

export function transfromKZ(data, interceptors) {
  return request({
    url: '/taobao/transfromSelfKz',
    method: 'post',
    data
  }, APIURLNEW, interceptors)
}

export function transform3Node(data, interceptors) {
  return request({
    url: '/yh/transform',
    method: 'post',
    data
  }, APIURLNEW, interceptors)
}

export function transformCjf(data, interceptors) {
  return request({
    url: '/taobao/getCjf',
    method: 'post',
    data
  }, APIURLNEW, interceptors)
}

export function transformSign(data, interceptors) {
  return request({
    url: '/taobao/newGen',
    method: 'post',
    data
  }, APIURLNEW, interceptors)
}


export function getSignProd ({...params}) {
  return request({
    url: `/score/web/signProd`,
    params
  }, APIURLNEW)
}

export function getSignRes (data) {
  return request({
    url: '/taobao/getSignRes',
    method: 'post',
    data
  }, APIURLNEW)
}

export function getCommonAct ({...params}) {
  return request({
    url: '/yh/activity',
    params
  }, APIURLNEW)
}


export function getJdProd () {
  console.log('222');
  return request({
    url: '/yh/jdProd',
  }, APIURLNEW)
}

export function jdPromotion(data, interceptors) {
  return request({
    url: '/newApp/promotion/1.0.0/jdPromotion',
    method: 'post',
    data
  }, baseURLCommon, interceptors)
}

export function jdPromotionHuan(data, interceptors) {
  return request({
    url: '/newApp/promotion/1.0.0/jdPromotionHuan',
    method: 'post',
    data
  }, baseURLCommon, interceptors)
}

export function jdPromotionSxy(data) {
  return request({
    url: '/api/jdPromotionSxy',
    method: 'post',
    data
  }, APIURLNEW)
}

export function pddPrivilege ({...params}) {
  return request({
    url: '/yh/pddPrivilege',
    params
  }, APIURLNEW)
}

export function pddPromotion ({...params}) {
  return request({
    url: '/yh/pddPromotion',
    params
  }, APIURLNEW)
}

export function getXianbao ({...params}) {
  return request({
    url: '/yh/xianbao',
    params
  }, APIURLNEW)
}

export function tbPrivilege (data) {
  return request({
    url: '/yh/tbPrivilege',
    method: 'post',
    data
  }, APIURLNEW)
}

export function getActivityRes (data) {
  return request({
    url: '/yh/activityRes',
    method: 'post',
    data
  }, APIURLNEW)
}

export function getJdGifg (data) {
  return request({
    url: '/newApp/product/1.0.0/getJdGift',
    method: 'post',
    data
  }, baseURLCommon)
}

export function getShyhRes () {
  return request({
    url: '/newApp/promotion/1.0.0/shyh',
  }, baseURLCommon)
}

export function getYhActProd () {
  return request({
    url: '/cps/prod',
  }, APIURLCPS)
}